import { render, staticRenderFns } from "./categoryDummy.vue?vue&type=template&id=a82579c2&scoped=true"
import script from "./categoryDummy.vue?vue&type=script&lang=js"
export * from "./categoryDummy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82579c2",
  null
  
)

export default component.exports